export default __webpack_public_path__ + "static/media/measure-group.6dcc2edc.svg";